/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useTravelerService } from "../../services/travelerService";
import { useUserContext } from "../../contexts/userContext";

/* Components */
import ProfileTabbedNav from "../../components/profileTabbedNav";

/* Styles */
import styles from "./styles";

const Profile = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const userDetails = useUserContext();
  
  const { travelerDetails } = useTravelerService(userDetails?.userInfo?.userEntityId);


  return (
    <div>
      <div className={classes.profilePageHeader}>
        <h1 className={classes.title}>
          {Object.keys(travelerDetails).length > 0 && travelerDetails?.firstName + " " + travelerDetails?.lastName}
        </h1>
      </div>
      <ProfileTabbedNav travelerDetails={travelerDetails}/>
    </div>
  )
}

export default Profile;
